var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50317 9.69817C8.21007 9.98843 7.73737 9.98737 7.44534 9.69534C6.42498 8.67498 4.28033 6.53033 4.28033 6.53033C3.98759 6.23759 3.98759 5.76241 4.28033 5.46967C4.57307 5.17693 5.04825 5.17693 5.34099 5.46967L7.99264 8.12132L10.6443 5.46967C10.937 5.17693 11.4122 5.17693 11.705 5.46967C11.9977 5.76241 11.9977 6.23759 11.705 6.53033C11.705 6.53033 9.53342 8.67923 8.50317 9.69817Z",
    fill: "#E3E6F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.a6611849f31b304d33dd801566185de6.svg";
export { ForwardRef as ReactComponent };